import { wrapLazily } from "../lazy-loading/lazyWrapper";

export const routes = () => {
	return [
		{
			path: "/search",
			component: wrapLazily(() => import("sd_articlesearch_ui/SearchPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				trackingName: "search",
				visibleForAnonymous: true,
			},
		},
		{
			path: "/category",
			childRoutes: [
				{
					path: "/category/*",
					component: wrapLazily(() => import("sd_articlesearch_ui/CategoryPage"), {
						usesBootstrap: true,
						usesMoment: true,
					}),
					routeParam: {
						trackingName: "category",
						visibleForAnonymous: true,
					},
				},
			],
		},
		{
			path: "/promotions",
			component: wrapLazily(() => import("sd_articlesearch_ui/PromotionsPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				trackingName: "promotions",
				visibleForAnonymous: true,
			},
		},
	];
};
